import styled from 'styled-components'
import Colors from '../../constants/colors'

export const ContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  font-style: normal;
  font-stretch: normal;
  .tagText {
    margin: 0 20px 0 20px;
  }
  .tagsSection {
    display: flex;
    flex-wrap: wrap;
  }
  .tagsHeader {
    font-family: StolzlMedium, serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 2px;
    margin-right: 34px;
    text-transform: uppercase;
    align-self: end;
  }
  .tag {
    min-width: 130px;
    border: 1px solid ${Colors.primary};
    border-radius: 100px;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: normal;
    text-align: center;
    height: 35px;
    line-height: 35px;
    margin-bottom: 10px;
    :not(:last-child) {
      margin-right: 10px;  
  }
`
